import { useState, useEffect } from 'react';
import { TESTIMONIALS } from '@/utils/constants';
import { MessageSquare } from 'lucide-react';
export default function Testimonials() {
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTestimonial((prev) => (prev + 1) % TESTIMONIALS.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="testimonials-section" data-testid="testimonials-section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Testimonials</h2>
                    <p className="section-subtitle">What our clients say</p>
                </div>
                <div className="testimonial-slider">
                    {TESTIMONIALS.map((testimonial, index) => (
                        <div
                            key={index}
                            className={`testimonial-item ${index === currentTestimonial ? 'active' : ''}`}
                            data-testid={`testimonial-${index}`}
                        >
                            <MessageSquare className="quote-icon" size={48} />
                            <p className="testimonial-text">{testimonial.text}</p>
                            <p className="testimonial-author">- {testimonial.author}</p>
                        </div>
                    ))}
                </div>
                <div className="testimonial-indicators">
                    {TESTIMONIALS.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentTestimonial ? 'active' : ''}`}
                            onClick={() => setCurrentTestimonial(index)}
                            data-testid={`testimonial-indicator-${index}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};